import { action, observable } from 'mobx';
import { CustomerTypeEnum } from 'app/types/customer';
import { language } from 'utils/i18n';
import URL from 'utils/URL';
import Device from './device';

const query = URL.current().query;
const ua = window.navigator.userAgent;

/**
 * @description 获取query中对应的key的值, 如果对应的是值是数组, 则取第一个元素, 否则返回该值
 * @param key 对应的query的key
 * @param latest 如果为true, 则从当前最新的url中获取query; 否则取进入项目时的query
 */
export function getQueryValue(key: string, latest: boolean = false): string | undefined {
    const curQuery = latest ? URL.current().query : query;
    const queryValue = curQuery[key];

    if (!queryValue) {
        return queryValue;
    }

    return Array.isArray(queryValue) ? queryValue[0] : queryValue;
}

function getStorageOrUrlValue<T = string>(key): T | undefined {
    let storage: any;

    try {
        storage = getQueryValue(key) || sessionStorage.getItem(key);
    } catch {}

    return storage;
}

function saveStorageValue(key, value) {
    try {
        sessionStorage.setItem(key, value);
    } catch {}
}

if (query.source) {
    saveStorageValue('source', getStorageOrUrlValue('source'));
}

export class UI {
    isTiger = /ihuhoo|tradeup|tigerbrokers/i.test(navigator.userAgent);
    isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(ua);
    isFireFox = /Firefox/i.test(ua);

    @action
    setShowLogo(show: boolean) {
        this.showLogo = show;
    }

    @action
    setLogoCustomerType(type?: CustomerTypeEnum) {
        this.logoCustomerType = type;
    }

    // app内不展示Logo
    @observable
    showLogo = !this.isTiger;

    @observable
    logoCustomerType: CustomerTypeEnum | undefined = undefined;

    device = new Device(this.isTiger);

    // 语言
    lang = language;

    // twitter 渠道相关邀请码
    twitterCodes = {
        TWITTER01: 1,
        TWITTER02: 1,
        TWITTER03: 1
    };

    // query相关内容
    query = query;
    source = getStorageOrUrlValue('source');
    customerServicePhone = '+1 973-228-2886';
}

export default new UI();
